<template>
  <form>
    <div>
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-8">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="pt-1">
                      <a class="h3" href="javascript:void(0)"
                        @click="$router.push('/job/index')"
                      >
                        <i id="back-to-job" class="uil-arrow-left mr-3"></i> 
                      </a>
                      <b-tooltip target="back-to-job" placement="top">{{$t('common.back_to').toUpperCase()}}  {{$t('job.singular').toUpperCase()}} </b-tooltip>
                    </div>

                    <div class="btn-group mb-2">
                      <button id="save-job" type="button" class="btn btn-light" @click="onUpdateJobs(model)">
                        Save
                      </button>
                      <b-tooltip target="save-job" placement="top">Save</b-tooltip>
                    </div>
                    <div v-if="!model.published" class="btn-group mb-2 ml-1">
                      <button id="post-job" type="button" class="btn btn-light" @click="onUpdateJobs(model, true)">
                        Save + <i class="uil-cloud-upload"></i>
                      </button>
                      <b-tooltip target="post-job" placement="top">Save + Post</b-tooltip>
                    </div>
                    <div v-if="model.url" class="btn-group mb-2 ml-1">
                      <button id="view-url" type="button" class="btn btn-light" @click="viewJobSource(model.url)">
                        <i class="uil-link-h"></i>
                      </button>
                      <b-tooltip target="view-url" placement="top">Source link</b-tooltip>
                    </div>

                    <div class="btn-group ml-1 mb-2">
                      <button id="preview-job" type="button" class="btn btn-light" @click="$refs.previewJob.show()">
                        <i class="uil-eye" />
                      </button>
                      <b-tooltip target="preview-job" placement="top">Preview</b-tooltip>
                    </div>  
                  </div>
                  <h4 class="header-title mt-md-5 mb-1">{{$t('job.form.information')}}</h4>
                  <p class="sub-header"></p>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="row border-bottom mb-3">
                        <TextField 
                          :placeholder="$t('job.form.title.placeholder')"
                          :label="$t('job.form.title.label')"
                          :error="$v.model.title.$error"
                          :errorMessage="$v.model.title.errorMessage"
                          v-model="model.title"
                          class="col-md-12"
                        />
                        <Select
                          disabled
                          autoload
                          class="col-md-6"
                          endpoint="all"
                          moduleName="company"
                          track-by="_id"
                          valueField="_id"
                          textField="name"
                          :placeholder="$t('job.form.company.placeholder')"
                          :label="$t('job.form.company.label')"
                          :error="$v.model.company_id.$error"
                          :errorMessage="$v.model.company_id.errorMessage"
                          v-model="model.company_id"
                          @selected="onCompanyChange"
                        />
      
                        <Select
                          autoload
                          class="col-md-6"
                          track-by=""
                          valueField=""
                          textField=""
                          moduleName="employment_type_options"
                          :placeholder="$t('job.form.employment_type.placeholder')"
                          :label="$t('job.form.employment_type.label')"
                          :error="$v.model.employment_type.$error"
                          :errorMessage="$v.model.employment_type.errorMessage"
                          v-model="model.employment_type"
                        />
      
                        <Select
                          autoload
                          moduleName="levels"
                          class="col-md-6"
                          track-by=""
                          textField=""
                          :placeholder="$t('job.form.experience.placeholder')"
                          :label="$t('job.form.experience.label')"
                          v-model="model.level"
                        />
      
                        <TextField 
                          :placeholder="$t('job.form.slots.placeholder')"
                          :label="$t('job.form.slots.label')"
                          :error="$v.model.slots.$error"
                          :errorMessage="$v.model.slots.errorMessage"
                          v-model="model.slots"
                          type="number"
                          class="col-md-6"
                        />
                      </div>
                    </div>
      
                    <!-- <TextField 
                      :placeholder="$t('job.form.reference_no.placeholder')"
                      :label="$t('job.form.reference_no.label')"
                      :error="$v.model.contract_length.$error"
                      :errorMessage="$v.model.contract_length.errorMessage"
                      v-model="model.reference_no"
                      type="number"
                      class="col-md-6"
                    /> -->
      
                    <Select
                      autoload
                      moduleName="jobTypes"
                      class="col-md-6"
                      valueField=""
                      textField=""
                      :placeholder="$t('job.form.job_type.placeholder')"
                      :label="$t('job.form.job_type.label')"
                      v-model="model.job_type"
                    />

                    <div class="form-group col-md-6">
                      <Multiselect
                        autoload
                        moduleName="function"
                        endpoint="all"
                        v-model="model.function_id"
                        :searchable="true"
                        :multiple="false"
                        :placeholder="$t('job.form.function.placeholder')"
                        :clear-on-select="false"
                        :close-on-select="false"
                        :show-labels="false"
                        track-by="_id"
                        label="name"
                        :textLabel="$t('job.form.function.label')"
                      />
                    </div>
      
                    <Select
                      autoload
                      moduleName="languageLevels"
                      valueField=""
                      textField=""
                      class="col-md-6"
                      :placeholder="$t('job.form.english.placeholder')"
                      :label="$t('job.form.english.label')"
                      v-model="model.english_level"
                    />
      
                    <!-- <TextField 
                      :placeholder="$t('job.form.contract_length.placeholder')"
                      :label="$t('job.form.contract_length.label')"
                      :error="$v.model.contract_length.$error"
                      :errorMessage="$v.model.contract_length.errorMessage"
                      v-model="model.contract_length"
                      type="number"
                      class="col-md-6"
                    /> -->
                    
                    <div class="form-group col-12">
                      <div id="editor-summarize" class="textOnInput">
                        <label for="">{{$t('job.form.summary.label')}}</label>
                        <quill-editor 
                          v-if="!computedSourceValidation"
                          id="editor1"
                          :placeholder="$t('job.form.summary.placeholder')"
                          v-model="model.summary"
                        />
                        <vue-editor
                          v-else
                          id="editor1"
                          :placeholder="$t('job.form.summary.placeholder')"
                          v-model="model.summary"
                        />
                      </div>
                    </div>
      
                    <div class="form-group col-12">
                      <div id="editor-rephrase" class="textOnInput">
                        <label for="">{{$t('job.form.full_details.label')}}</label>
                        <quill-editor
                          v-if="computedSourceValidation"
                          id="editor2"
                          :placeholder="$t('job.form.full_details.placeholder')"
                          v-model="model.description"
                        />
                        <vue-editor
                          v-else
                          id="editor2"
                          :placeholder="$t('job.form.full_details.placeholder')"
                          v-model="model.description"
                        />
                      </div>
                    </div>
      
                    <div class="form-group col-12">
                      <div class="textOnInput">
                        <label for="">{{$t('job.form.additional_information.label')}}</label>
                        <quill-editor
                          v-if="computedSourceValidation"
                          id="editor3"
                          :placeholder="$t('job.form.additional_information.placeholder')"
                          v-model="model.remarks"
                        />
                        <vue-editor
                          v-else
                          id="editor3"
                          :placeholder="$t('job.form.additional_information.placeholder')"
                          v-model="model.remarks"
                        />
                      </div>
                    </div>
      
                  </div>
                </div>
              </div>
            </div>
            
            <div class="col-sm-4">
              <div class="card">
                <div class="card-body">
                  <div class="row justify-content-between">
                    <div></div>
                    <div class="row">
                      <!-- <Button @click="prevPage" />
                       -->
                      <span class="mr-1">Showing {{ getCurrentData(currentJobID || jobID) }} of {{ editableData.length }}</span>
                       <router-link
                        class="btn btn-soft-primary btn-xs mx-1 mb-1"
                        tag="button"
                        to=""
                        :style="currentPage == 0 ? 'border: 1px solid #999999; background-color: #cccccc;color: #666666; cursor: not-allowed;' : ''"
                        @click.native="prevPage"
                      >
                        <i class="uil uil-angle-left"></i>
                      </router-link>
                      <!-- <Button @click="nextPage" /> -->
                      <router-link
                        class="btn btn-soft-primary btn-xs mx-1 mb-1"
                        tag="button"
                        to=""
                        :style="currentPage == editableData.length - 1 ? 'border: 1px solid #999999; background-color: #cccccc;color: #666666; cursor: not-allowed;' : ''"
                        @click.native="nextPage"
                      >
                        <i class="uil uil-angle-right"></i>
                      </router-link>
                    </div>
                  </div>
                  <div class="button_style mr-md-4"> 
                    <!-- <router-link
                        class="btn btn-xs mx-1 mb-1 px-4 py-2 ml-1 btn-primary"
                        tag="button"
                        to=""
                        @click.native="onUpdateJobs(model)"
                      >
                      <span>UPDATE</span>
                    </router-link> -->
                    <!-- <div class="col-sm-12 col-xl-8 text-sm-right"> -->
                      <!-- <div class="btn-group d-sm-inline-block mr-1">
                          <router-link
                            class="btn2 btn2-primary btn-sm"
                            tag="button"
                            to=""
                            @click.native="onUpdateJobs(model)"
                          >
                            <i class="uil uil-edit mr-1"></i>{{$t('common.save')}}
                          </router-link>
                      </div> -->
                    <!-- </div> -->
                  </div>
                  <h4 class="header-title mt-0 mb-1 mt-md-5">{{ $t('job.form.financing') }}</h4>
                  <p class="sub-header"></p>
                  <div class="row mb-3">
                    <!-- <TextField 
                      placeholder="xxx,xxx"
                      label="Min Salary"
                      type="number"
                      class="col-md-6"
                      v-model="model.min_salary"
                    /> -->
                    <Select
                      autoload
                      moduleName="currency"
                      endpoint="all"
                      class="col-md-6"
                      :placeholder="$t('job.form.currency.placeholder')"
                      :label="$t('job.form.currency.label')"
                      :error="$v.model.currency_id.$error"
                      :errorMessage="$v.model.currency_id.errorMessage"
                      v-model="model.currency_id"
                      @selected="onSelectCurrency"
                    />
                    <div class="row col-md-12">
                      <div class="form-group col-md-12">
                        <b-form-checkbox 
                          v-model="model.use_min_max_salary" 
                          name="check-button" 
                          switch
                          @change="onBlur"
                        >
                          Min and Max Salary
                        </b-form-checkbox>
                      </div>
                      <div class="form-group col-md-6" v-if="model.use_min_max_salary">
                        <label for="" class="form-label">{{ $t('job.form.min_salary.label') }}</label>
                        <currency-input
                          class="form-control"
                          placeholder="xxx,xxx"
                          v-model="model.min_salary"
                          :precision="!isYenCurrency ? 2 : 0"
                        />
                      </div>

                      <div class="form-group col-md-6" v-if="model.use_min_max_salary">
                        <label for="" class="form-label">{{ $t('job.form.max_salary.label') }}</label>
                        <currency-input
                          class="form-control"
                          placeholder="xxx,xxx"
                          v-model="model.max_salary"
                          :precision="!isYenCurrency ? 2 : 0"
                        />
                      </div>
                      <TextField 
                        :placeholder="$t('job.form.salary_range')"
                        :label="$t('job.form.salary_range')"
                        v-model="model.salary"
                        class="col-md-6"
                        v-if="!model.use_min_max_salary"
                      />
                    </div>
      
                  </div>
      
                  <h4 class="header-title mt-0 mb-3">{{ $t('job.form.commission_setup') }}</h4>
                  <div class="form-group">
                    <b-form-checkbox 
                      v-model="model.fixed" 
                      name="check-button" 
                      switch
                      @change="onBlur"
                    >
                      {{ $t('job.form.use_fixed_rate') }}
                    </b-form-checkbox>
                  </div>
                  <div class="row">
                    <TextField 
                      :max="model.fixed ? 0 : 100"
                      :placeholder="model.fixed ? 'xx,xxx' : '%'"
                      :label="$t('job.form.commission_rate.label')"
                      type="number"
                      class="col-md-6"
                      v-model="model.rate"
                    />
      
                    <Select
                      autoload
                      moduleName="paymentTerms"
                      valueField=""
                      textField=""
                      class="col-md-6"
                      :placeholder="$t('job.form.payment_term.placeholder')"
                      :label="$t('job.form.payment_term.label')"
                      v-model="model.payment_term"
                    />
      
                    <div class="form-group col-md-6">
                      <div class="textOnInput">
                        <label class="form-control-label">
                          {{ $t('job.form.city.label') }}
                        </label>
                        <CustomSelect
                          v-model="model.city"
                          :options="cities"
                          :searchable="true"
                          :placeholder="$t('job.form.city.placeholder')"
                          :clear-on-select="false"
                          :close-on-select="true"
                          :show-labels="false"
                          
                          track-by="value"
                          label="text"
                          textField="text"
                          valueField="value"
                          @tag="addTagCity"
                          :taggable="true"
                          :multiple="false"
                        />
                    </div>
                      </div>
      
                    <!-- <TextField 
                      :placeholder="$t('job.form.city.placeholder')"
                      :label="$t('job.form.city.label')"
                      :error="$v.model.city.$error"
                      :errorMessage="$v.model.city.errorMessage"
                      v-model="model.city"
                      class="col-md-6"
                    /> -->
      
                    <TextField 
                      :placeholder="$t('job.form.country.placeholder')"
                      :label="$t('job.form.country.label')"
                      :error="$v.model.country.$error"
                      :errorMessage="$v.model.country.errorMessage"
                      v-model="model.country"
                      class="col-md-6"
                    />

                    <!-- <Select
                      moduleName="company"
                      endpoint="getContactPersons"
                      class="col-md-12"
                      ref="contactPersons"
                      :placeholder="$t('job.form.contact_person.placeholder')"
                      :label="$t('job.form.contact_person.label')"
                      v-model="model.contact_person"
                      :autoload="true"
                      track-by="_id"
                      textField="email"
                      :parameters="{
                        id: model.company_id._id
                      }"
                    /> -->

                    <!-- <div class="form-group col-md-12">
                      <Multiselect
                        autoload
                        moduleName="industry"
                        endpoint="all"
                        v-model="model.industry_id"
                        :searchable="true"
                        :multiple="false"
                        :placeholder="$t('job.form.industry.placeholder')"
                        :clear-on-select="false"
                        :close-on-select="false"
                        :show-labels="false"
                        track-by="_id"
                        label="name"
                        :textLabel="$t('job.form.industry.label')"
                      />
                    </div> -->
                    <div class="form-group col-md-12">
                      <div class="textOnInput">
                        <label for="" class="form-label">{{$t('job.form.skills.label')}}</label>
                        <vue-tags-input
                          class="form-group"
                          v-model="model.tag"
                          :tags="model.tags"
                          @tags-changed="newTags => model.tags = newTags"
                          :placeholder="$t('job.form.skills.placeholder')"
                        />
                      </div>
                    </div>
                  </div>
      
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>

    <Dialog
      centered
      ref="confirmationModal"
      :titleHtml="'<i class=\'uil-comment-alt-check mr-1\'></i> Confirmation'"
      size="md"
      yesText="Confirm"
      noText="Cancel"
      :parameters="{ is_next }"
      :component="computedConfirmationComponent"
      :buttonDisable="confirmed"
      @onYes="onConfirm"
    />

    <OffCanvas
      centered
      title="Preview Job"
      ref="previewJob"
      bodyClass="modalBodyContainer px-4"
      size="xl"
      :component="computedViewJobComponent"
      :parameters="{ model, hasNoSetting: true, submitted }"
    />

    <Loading ref="loading"/>

  </form>
</template>

<script>
import FormMixin from '@mixins/form'
import { required } from 'vuelidate/lib/validators'
import { VueEditor } from 'vue2-editor'
import error from '@utils/error'
import Dialog from '@components/dialogs'
import OffCanvas from '@components/offcanvas'
import ConfirmationComponent from './confirmation.vue'
import Dropdown from '@src/static/dropdown'
import { mapActions } from 'vuex'
import VueTagsInput from '@johmun/vue-tags-input';
import Loading from '@components/LoadingSpinner'
import CustomSelect from 'vue-multiselect'
// import { Quill } from 'vue-quill-editor'
// var Block = Quill.import('blots/block');
// Block.tagName = 'DIV';
// Quill.register(Block, true)

export default {
  components: {
    TextField: () => import('@components/form2/textfield.vue'),
    // DropDown: () => import('@components/form2/select.vue'),
    Multiselect: () => import('@components/form2/select/multiselect'),
    Select: () => import('@components/form2/select'),
    VueEditor,
    Dialog,
    OffCanvas,
    VueTagsInput,
    Loading,
    CustomSelect
  },
  mixins: [ FormMixin ],
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  validations: {
    model:{
      title: { required },
      country: { required },
      city: { required },
      company_id: { required },
      industry_id: { required },
      employment_type: { required },
      currency_id: { required },
      slots: { required },
      contract_length: { required },
      tag: String,
      tags: Array
    }
  },
  computed: {
    computedSourceValidation () {
      let defaultEditor = (this.model.webcrawler ? this.model.webcrawler.type.defaultEditor : false) ? !this.model.innerHTML : false

      return defaultEditor; 
    },
    isEditModalOpen() {
      let parameters = this.parameters || {}
      return parameters.isEditModalOpen
    },
    jobID() {
      let query = this.$route.query || {}
      return query.id
    },
    genPrecision(){
      let currentCurrency = this.currency_options.filter(el => {return el.symbol == '¥' && this.model.currency_id == el.value})

      return currentCurrency.length ? 0 : 2
    },
    computedConfirmationComponent() {
      return ConfirmationComponent;
    },
    computedConfirmationValidation() {
      const oldData = this.original_model
      const newData = this.model

      return oldData.title !== newData.title 
      || oldData.company_id !== newData.company_id 
      || oldData.employment_type !== newData.employment_type 
      || oldData.level !== newData.level 
      || oldData.slots !== newData.slots 
      || oldData.reference_no !== newData.reference_no 
      || oldData.job_type !== newData.job_type 
      || oldData.english_level !== newData.english_level 
      || oldData.summary !== newData.summary 
      || oldData.description !== newData.description 
      || oldData.remarks !== newData.remarks 
      || oldData.currency_id !== newData.currency_id 
      || oldData.salary !== newData.salary 
      || oldData.rate !== newData.rate 
      || oldData.payment_term !== newData.payment_term 
      || oldData.city !== newData.city
      || oldData.country !== newData.country
      || oldData.contract_length !== newData.contract_length
      || oldData.function_id !== newData.function_id
      || oldData.industry_id !== newData.industry_id
      || oldData.fixed !== newData.fixed
      || oldData.use_min_max_salary !== newData.use_min_max_salary
    },
    computedViewJobComponent() {
      return () => import('./view.vue')
    }
  },
  data () {
    return {
      Dropdown,
      model:{
        company_id:'',
        title:'',
        city:'',
        country:'',
        employment_type:'',
        industry:'',
        level:'',
        summary:null,
        description:null,
        remarks:null,
        min_salary:null,
        max_salary:null,
        rate:null,
        industry_id: [],
        function_id: [],
        currency_id: [],
        slots:0,
        contract_length: 0,
        fixed:false,
      },
      original_model: {},
      fullWidth:document.getElementsByClassName('content-page').item(0).clientWidth,
      isEditModel: false,
      variant: 'dark',
      variants: [
        'transparent',
        'white',
        'light',
        'dark',
        'primary',
        'secondary',
        'success',
        'danger',
        'warning',
        'info',
      ],
      saveFunc: false,
      currentPage: '',
      currentJobID: '',
      editableData: [],
      submitted: false,
      confirmed: false,
      is_next: false,
      is_prev: false,
      cities: [],
      is_mounted: false,
      isYenCurrency: false
    }
  },
  methods: {
    ...mapActions('company', {'findCompany':'find'}),
    onBlur(){
      if(parseInt(this.model.rate) > 100){
        this.model.rate = 100
      }
    },
    onCompanyChange(val) {
      let selected = { ...val }
      if (selected && Object.entries(selected).length) {
        this.model.rate = selected.rate.$numberDecimal
        this.model.industry_id = selected.industry_id
        this.model.function_id = selected.function_id
        this.model.fixed = selected.fixed
        this.model.remarks = this.model.remarks ? this.model.remarks : selected.remarks
        this.model.city = selected.city
        this.model.country = selected.country
        if(this.is_mounted){
          this.original_model = { ...this.model }
          this.is_mounted = false
        }

        // this.$refs.contactPersons.params.id = val._id
        // this.$refs.contactPersons.fetchData()
        // this.$store.dispatch('company/find',{
        //   id:val._id
        // }).then(data => {
        //   var _data = data.data
        //   if(_data.default_contact)
        //     this.model.contact_person = _data.default_contact
        // })
      }
    },
    async fetchJobs(ID) {
      // this.model = {}
      let id = ID ? ID : this.jobID
      if(id){
        this.$store.dispatch('job/find', { id })
        .then(data => {
          this.model = { ...data.data }
          this.model.min_salary = data.data.min_salary ? parseFloat(data.data.min_salary.$numberDecimal) : 0
          this.model.max_salary = data.data.max_salary ? parseFloat(data.data.max_salary.$numberDecimal) : 0
          this.model.rate = data.data.rate ? data.data.rate.$numberDecimal : 0
          this.model.id = data.data._id
          this.model.remarks = data.data.remarks ? data.data.remarks : data.data.company_id.remarks
          this.currentJobID = id
          // this.addTagCity(this.model.city)
          this.model.city = {
            text: this.model.city,
            value: this.model.city
          }

          this.original_model = { ...this.model }
          // this.fetchButtons()
          // this.is_mounted = true
          this.getCurrencyList()
        })
      }
    },
    async fetchData(){
      let params = {}

      params.type = 'active'
      params.job_status = 'all'
      params.is_editable = true
      params.sort_by = 'date_created'
      params.sort_desc = true

      return this.$store.dispatch('job/pagination', { ...params })
      .then(res => {
        this.editableData = res.data.data || []
        this.fetchButtons()
      })

    },
    getCurrentData(val){
      let data = this.editableData
      for(let key in data){
        if(data[key]._id == val){
          this.currentPage = parseInt(key)
          return this.currentPage + 1
        }
      }
    },
    nextPage(){
      this.is_next = false
      if(this.computedConfirmationValidation){
        this.is_next = true
        this.$refs.confirmationModal.show()
      }else{
        let data = this.editableData
        if(this.currentPage < data.length){
          this.currentPage++
          for(let key in data){
            let page = parseInt(key)
            if(this.currentPage == page){
              let newJobID = data[key]._id
              this.$route.query.id = newJobID
              this.fetchJobs(newJobID)
            }
          }
        }
      }
    },
    prevPage(){
      this.is_next = false
      if(this.computedConfirmationValidation){
        this.$refs.confirmationModal.show()
      }else{
        let data = this.editableData
        if(this.currentPage > 0){
          this.currentPage--
          for(let key in data){
            let page = parseInt(key)
            if(this.currentPage == page){
              let newJobID = data[key]._id
              this.$route.query.id = newJobID
              this.fetchJobs(newJobID)
            }
          }
        }
      }
    },
    onConfirm(){
      this.$refs.confirmationModal.hide()
      this.model = { ...this.original_model }
      if(this.is_next){
        this.nextPage()
      }else{
        this.prevPage()
      }
      this.is_next = false
    },
    getCityList(){
      let cityList = this.Dropdown.cityList.map( res => {
        return res.replace(/\s+/g, '').toLowerCase();
      })
      .sort(function(a, b){return a.localeCompare(b)});
      
      for(let key in cityList){
        let city = {}
        city.value = cityList[key]
        city.text = cityList[key]
        this.cities.push(city)
      }
    },
    viewJobSource(url) {
      window.open(url, '_blank').focus();
    },
    onUpdateJobs(val, isPost = false){
      this.$bvModal.msgBoxConfirm(`Please confirm that you want to ${isPost ? 'save & post' : 'save' } this job${isPost ? ' (this action is one time only)' : ''}.`, {
        title: 'Please Confirm Action',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(res => {
        this.submitted = res;
        if(this.submitted) {
          let model = val && val.model && Object.entries(val.model).length ? val.model : val
          model.id = model._id ? model._id : model.id

          model.city = model.city.text
          return this.$store.dispatch('job/update', model)
          .then(res => {
            if (res && res.data) {
              this.$bvToast.toast(`${res.data.job.title} successfully updated!`, {
                title: "Notification",
                variant: "success"
              })
              if(!isPost){
                setTimeout(() => {
                  this.submitted = false;
                  this.original_model = {...this.model}
                  this.nextPage()
                }, 1500)
              } else {
                let job = res.data
                // this.toggleLoading()
                this.$store.dispatch('job/publishJob', {
                  id:model._id,
                  published: !job.published
                })
                .then(res => {
                  if(res.data.published || !res.data.published){
                    this.$bvToast.toast(`Job #${res.data.reference_no} has been posted!`, {
                      title: 'Notification',
                      variant:'success'
                    })
  
                    setTimeout(() => {
                      this.submitted = false;
                      this.original_model = {...this.model}
                      this.nextPage()
                    }, 1500)
                    
                    // this.toggleLoading()
                  }
                }).catch(() => {
                  this.$bvToast.toast(`Job #${model.reference_no} error on posting!`, {
                    title: 'Notification',
                    variant:'warning'
                  })
                })
              }
            }
          })
          .catch(err => error.errorHandler(err, this.$bvToast))
        }
      })
      .catch(err => error.errorHandler(err, this.$bvToast))
    },
    onSelectCurrency(val) {
      this.isYenCurrency = false
      if(val != null && val.code == "JPY") {
        this.isYenCurrency = true
      }
    },
    fetchButtons() {
      let buttons = [
        'rephrase' , 'summarize'
      ]

      for(var key in buttons) {
        let btnName = buttons[key]
        var editor = document.getElementById(`editor-${btnName}`)

        if(editor) {
          var toolbar = editor.querySelector('.ql-toolbar.ql-snow')
    
          // console.log('toolbar', editor)
          toolbar.style.cssText = 'padding-right: 110px; min-height: 65px;';
          
          const button = document.createElement("button");  
          button.size = "md"
          button.type = "button"
          button.className = "btn2 btn2-primary-custom btn2-md w-100 "
          button.style.cssText = 'height: 50px !important; float: right; font-size: 15px !important; line-height: 10px !important;';
          button.innerHTML = `<div class="row justify-content-center" style="vertical-align: middle;"> <span id="label"> ${btnName.toUpperCase()} </span> </div>`
    
          button.addEventListener("click", function() {
            this.onUpdateDescription(btnName, `${btnName}Description`)
          }.bind(this), false);
    
          const nodes = document.createElement("div");
          nodes.style.cssText = 'display: grid; justify-content: end; width: 100px; top: 0; right: 5px; position: absolute;';
          nodes.className = "py-2"
          nodes.appendChild(button);
    
          // Append the "span" node to the list:
          toolbar.appendChild(nodes);

        }

      }
    },
    onUpdateDescription(name = 'rephrase', endpoint = 'rephraseDescription') {
      let { model } = this
      this.$bvModal.msgBoxConfirm(`Please confirm that you want to ${name} job description.`, {
        title: 'Please Confirm Action',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(res => {
        if(res) {
          this.$refs.loading.start(true)

          this.$store.dispatch(`job/${endpoint}`, {
            id: model.id
          })
          .then( result => {
            if(result) {
              console.log('rrr', result)
              this.$refs.loading.stop()
              let { data } = result.data
              let { new_html_job, summary } = data

              console.log('ddd', new_html_job, summary)
              let field = name == 'rephrase' ? 'description' : 'summary'

              let value = name == 'rephrase' ? new_html_job : summary

              if(value == undefined) {
                this.$bvToast.toast(`Job description error on ${name == 'rephrase' ? 'rephrasing' : 'summarizing'}!!`, {
                  title: 'Notification',
                  variant:'danger'
                })

                return false
              }
              this.model[field] = name == 'rephrase' ? new_html_job : summary
            }
              // this.fetchJobs()


            this.$bvToast.toast(`Job description has been ${name == 'rephrase' ? 'rephrased' : 'summarized'}!`, {
              title: 'Notification',
              variant:'success'
            })
          })
          .catch(() => {
            this.$bvToast.toast(`Job description error on ${name == 'rephrase' ? 'rephrasing' : 'summarizing'}!!`, {
              title: 'Notification',
              variant:'danger'
            })
          })
          
        }
      })
    },
    getCurrencyList() {
      this.$store.dispatch('currency/all').then( res => {
        if(res && res.data) {
          let defaultCurrency = res.data.filter( res => res.code == 'JPY')
          if(defaultCurrency.length > 0)
            this.model.currency_id = { ...defaultCurrency[0] }
        }
      }) 
    },
    addTagCity(val) {
      let newTag = val.toString()
      let isTag = this.cities.filter(el => { return el.value == newTag })

      let option = { 'text': newTag, 'value': newTag }
      if(isTag.length == 0){
        this.cities.push(option)
        this.model.city = option
      }
    },
  },
  mounted() {
    if(!this.jobID || this.jobID == undefined){
      this.$router.push('/job/index')
    }
    this.fetchJobs()
    this.fetchData()
    this.getCityList()
  },
  watch: {
    jobID: function () {
      this.fetchJobs()
    }
  }
}
</script>

<style lang="scss">
  .quill-editor {
    .ql-container {
      .ql-editor{
        h2 {
          font-size: 20px!important;
        }
        h3 {
          font-size: 17px!important;
        }
        h4 {
          font-size: 14px!important;
        }
      }
    }
  }
  .vue-tags-input {
    max-width: 100%!important;
    position: relative !important;
    background-color: #fff !important;
  }
  .ti-input {
    display: block;
    width: 100%;
    min-height: calc( 1.5em + 1rem + 2px );
    padding: 0.5rem 0.75rem;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #4b4b5a;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #e2e7f1;
    border-top-color: rgb(226, 231, 241);
    border-top-style: solid;
    border-top-width: 1px;
    border-right-color: rgb(226, 231, 241);
    border-right-style: solid;
    border-right-width: 1px;
    border-bottom-color: rgb(226, 231, 241);
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-left-color: rgb(226, 231, 241);
    border-left-style: solid;
    border-left-width: 1px;
    border-image-source: initial;
    border-image-slice: initial;
    border-image-width: initial;
    border-image-outset: initial;
    border-image-repeat: initial;
    border-radius: 0.3rem;
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;
    border-bottom-right-radius: 0.3rem;
    border-bottom-left-radius: 0.3rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition-property: border-color, box-shadow;
    transition-duration: 0.15s, 0.15s;
    transition-timing-function: ease-in-out, ease-in-out;
    transition-delay: 0s, 0s;
  }
  .ti-tag.ti-valid {
    position: relative;
    padding: 4px 26px 4px 10px;
    border-radius: 5px;
    margin-right: 10px;
    color: #fff;
    line-height: 1;
    white-space: nowrap;
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis;
    z-index: 2;
    margin-bottom: 0 !important;
    background-color: #5369f8 !important;
  }
  .ti-actions {
    cursor: pointer;
    margin-left: 7px;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    font-weight: 700;
    font-style: normal;
    width: 22px;
    text-align: center;
    line-height: 22px;
    transition: all .2s ease;
    border-radius: 5px;
  }
  .sticky-button {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
  }
  .button_style {
    position: fixed;
    top: 5;
    bottom: 10;
    right: 15px;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #editor1 .ql-editor, #editor2 .ql-editor, #editor3 .ql-editor{
    max-height: 500px;
    overflow-y: scroll;
  }

  .multiselect__tag{
    z-index: 2;
  }

  .btn2-primary-custom {
    background: #030013 !important;
    color: #FFFFFF !important;
    height: 50px !important; 
    float: right; font-size: 15px !important; line-height: 10px !important;

    &:active {
      background: #EB2F5B !important;
      border-color: #EB2F5B !important;
    }
  }
</style>
